module.exports = __webpack_public_path__ + "img/eliza2.ed1b1d12.png";